
import { FETCH_PETSHOPS, CREATE_PETSHOP, UPDATE_PETSHOP, DELETE_PETSHOP, FETCH_PETSHOPS_BY_EMAIL, SET_CURRENT_PETSHOP, ADD_LOGO, GET_PETSHOP_BY_DOMAIN, CHECK_PETSHOP_N_USER } from '../actions';
import { NotificationManager } from 'react-notifications';
const initialState = {
  currentPetshop: null,
  selectedToDelete: null,
  selectedToEdit: null,
  setPetShop: null,
  updatePetShop: null,
  petShops: [],
  petShopsbyEmail: [],
  petShopbyDomain: null,
  loading: false,
  updatePetShopError:null,
  setPetShopError:null,
  petShopsError:null,
  selectedToDeleteError:null,
  petShopsbyEmailError:null,
  currentPetshopError:null,
  newLogoError:null,
  petShopbyDomainError:null,
  petshopNUserError: null,
  petShopNUser: null
};

function petShopReducer(state = initialState, action) {
  let selectedToDelete,
    selectedToEdit,
    petShops,
    setPetShop,
    updatePetShop,
    petShopsbyEmail,
    currentPetshop,
    petShopbyDomain,
    newLogo,
    petShopNUser;
  switch (action.type) {
    case `${UPDATE_PETSHOP}_PENDING`:
    case `${CREATE_PETSHOP}_PENDING`:
    case `${FETCH_PETSHOPS}_PENDING`:
    case `${DELETE_PETSHOP}_PENDING`:
    case `${FETCH_PETSHOPS_BY_EMAIL}_PENDING`:
    case `${SET_CURRENT_PETSHOP}_PENDING`:
    case `${ADD_LOGO}_PENDING`:
      return { ...state, error: null, loading: true};
      
    case `${CHECK_PETSHOP_N_USER}_PENDING`:
      return { ...state, error: null, loading: true, petShopNUser: null};
    
    case `${GET_PETSHOP_BY_DOMAIN}_PENDING`:
      return { ...state, loading: true, error: null, petShopbyDomain: null };

    case `${UPDATE_PETSHOP}_FULFILLED`:
      updatePetShop = action.payload.data;
      return { ...state, loading: false, updatePetShop };

    case `${CREATE_PETSHOP}_FULFILLED`:
      setPetShop = action.payload.data;
      return { ...state, loading: false, setPetShop };

    case `${FETCH_PETSHOPS}_FULFILLED`:
      petShops = action.payload.data;
      return { ...state, loading: false, petShops };

    case `${DELETE_PETSHOP}_FULFILLED`:
      selectedToDelete = action.payload.data;
      return { ...state, loading: false, selectedToDelete };

    case `${FETCH_PETSHOPS_BY_EMAIL}_FULFILLED`:
      petShopsbyEmail = action.payload.data;
      return { ...state, loading: false, petShopsbyEmail };

    case `${SET_CURRENT_PETSHOP}_FULFILLED`:
      currentPetshop = action.payload.data;
      return { ...state, loading: false, currentPetshop };

    case `${ADD_LOGO}_FULFILLED`:
      newLogo = action.payload.data;
      return { ...state, loading: false, newLogo };

    case `${GET_PETSHOP_BY_DOMAIN}_FULFILLED`:
      petShopbyDomain = action.payload.data;
      return { ...state, loading: false, petShopbyDomain };
      
    case `${CHECK_PETSHOP_N_USER}_FULFILLED`:
      petShopNUser = action.payload.data;
      return { ...state, loading: false, petShopNUser };

    case `${UPDATE_PETSHOP}_REJECTED`:
      return {...state, loading: false, updatePetShopError: `${action.payload.response.data.details.message}`, state: initialState };
    case `${CREATE_PETSHOP}_REJECTED`:
      return {...state, loading: false, setPetShopError: `${action.payload.response.data.details.message}`, state: initialState };
    case `${FETCH_PETSHOPS}_REJECTED`:
      return {...state, loading: false, petShopsError: `${action.payload.response.data.details.message}`, state: initialState };
    case `${DELETE_PETSHOP}_REJECTED`:
      return {...state, loading: false, selectedToDeleteError: `${action.payload.response.data.details.message}`, state: initialState };
    case `${FETCH_PETSHOPS_BY_EMAIL}_REJECTED`:
      return {...state, loading: false, petShopsbyEmailError: `${action.payload.response.data.details.message}`, state: initialState };
    case `${SET_CURRENT_PETSHOP}_REJECTED`:
      return {...state, loading: false, currentPetshopError: `${action.payload.response.data.details.message}`, state: initialState };
    case `${ADD_LOGO}_REJECTED`:
      return { loading: false, newLogoError: `${action.payload.message}`, ...initialState };
    case `${GET_PETSHOP_BY_DOMAIN}_REJECTED`:
      return {...state, loading: false, petShopbyDomainError: `${action.payload.response.data.details.message}`, state: initialState };
    case `${CHECK_PETSHOP_N_USER}_REJECTED`:
      return {...state, loading: false, petshopNUserError: action.payload.response.data.details.msg, state: initialState };

    default:
      return state;
  }
}

export default petShopReducer;
